module.exports = __webpack_public_path__ + "img/notification-icon.12accf23.webp";